import "./SectionTitle.css";

type SectionTitleProps = {
  title: string;
};

export function SectionTitle({ title }: SectionTitleProps) {
  return (
    <div className="section-title-wrap">
      <h2>{title}</h2>
    </div>
  );
}
